module.exports = __webpack_public_path__ + "img/card1-1.0279fcac.png";